<template>
  <div class="access-column-header">
    <span>{{ params.displayName }}</span>
    <BittsTooltip
      placement="top"
      :mount-to-body="true"
      overlay-class="max-w-[200px] text-left"
    >
      <FontAwesomeIcon
        :icon="['fak', 'information-circle']"
        class="text-neutral-accent"
        :style="{ height: '13px', width: '13px', cursor: 'default' }"
      />
      <template #title>
        <span class="text-left block"
          >Admins can view all reports, including private ones</span
        >
      </template>
    </BittsTooltip>
  </div>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { params } = defineProps<{
  params: {
    displayName: string;
  };
}>();
</script>

<style lang="pcss">
@reference "../../css/theme.css";
.access-column-header {
  @apply flex items-center justify-center gap-4 text-sm font-extrabold text-neutral-text-strong truncate;
}
</style>
